module.exports = __webpack_public_path__ + "assets/img/1512_01.jpg?f85e6b88c1fdec39949639122abdd49e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1512_01.jpg
// module id = 1091
// module chunks = 0